import { useMutation } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { RECEIPT: { VERSION, BASE } } } = USER;

const categorizedTransaction = (categorizeData: any) => httpService.post((`${BASE_URL}/api/${VERSION}/user/${categorizeData.customerId}/${BASE}/${categorizeData.transactionId}/categories`), categorizeData.categoryDetails);

export const useCategorizeTransactionMutation = () => useMutation(categorizedTransaction);
